import { render, staticRenderFns } from "./BridgePhotosView.vue?vue&type=template&id=5bcb1da6"
import script from "./BridgePhotosView.vue?vue&type=script&lang=ts"
export * from "./BridgePhotosView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports